// The "View" menu shown when the user clicks the kebab (⋯) button on
// the right of the editor toolbar. Lets the user switch how `{TOKEN}`
// literals are rendered:
//   - Preview : each token renders as an atomic pill (default)
//   - Source  : tokens render as plain literal text, fully editable
//
// Rendered inside a `PopupMenuButton` popover — the current `mode` and
// the `onSetMode` callback arrive via `menuParams`.

import React from 'react'

import PopoverMenuOption from "../popover-menu/popover-menu/menu-option"
import {ViewMode} from './types'


const VIEW_OPTIONS: Options = [
    {value: 'preview', label: 'Preview'},
    {value: 'source',  label: 'Source'},
]


type Props = {
    menuParams  : {
        mode      : ViewMode
        onSetMode : (mode: ViewMode) => void
    }
    hidePopover : callback
}


export default function TextareaWithVariablesViewModeMenu(props: Props) {

    const {mode, onSetMode} = props.menuParams

    const onClick = (option: Option) => {
        if (option.value !== mode) onSetMode(option.value)
        props.hidePopover()
    }

    return (
        <div className="ui5-popover-menu min-w-150">
            {VIEW_OPTIONS.map((option: Option, key: number) => (
                <PopoverMenuOption key      = {key}
                                   option   = {option}
                                   selected = {option.value === mode}
                                   onClick  = {onClick}/>
            ))}
        </div>
    )
}
